import React from "react";
import { Camera, PenLine, Check, X, Loader2 } from "lucide-react";
import {
  getPrimaryStopDetails, getPrimaryStopSummary,
} from "../helpers";
import { SignaturePad } from "../SignaturePad";
import { DriverHeader } from "../DriverHeader";

export function PodScreen(ctx) {
  const {
    driverInfo, selectedJob, multiPodJobs, allItems,
    podPhoto, setPodPhoto, podSignature, setPodSignature,
    podSignedBy, setPodSignedBy, podNote, setPodNote,
    showSignature, setShowSignature,
    saving,
    pushEnabled, installPrompt, setInstallPrompt,
    setShowScanner, togglePush, logout, navigateTo, goBack,
    capturePhoto, submitPod, setMultiPodJobs,
  } = ctx;

  const isMulti = multiPodJobs.length > 0;
  const job = isMulti ? null : (allItems.find((i) => i.id === selectedJob.id) || selectedJob);

  return (
    <div className="min-h-screen bg-zinc-100" data-testid="driver-app">
      <DriverHeader showBack title={isMulti ? `Consegna multipla (${multiPodJobs.length})` : "Conferma Consegna"} driverInfo={driverInfo} goBack={goBack} navigateTo={navigateTo} togglePush={togglePush} pushEnabled={pushEnabled} setShowScanner={setShowScanner} installPrompt={installPrompt} setInstallPrompt={setInstallPrompt} logout={logout} />
      <div className="px-4 py-4 space-y-4">
        {isMulti ? (
          <div className="bg-white rounded-lg border border-zinc-200 p-3 space-y-2" data-testid="multi-pod-summary">
            <p className="text-[10px] font-bold uppercase tracking-widest text-[#FF5200]">Firma unica per {multiPodJobs.length} consegne</p>
            <div className="space-y-1 max-h-40 overflow-auto">
              {multiPodJobs.map((j) => (
                <div key={j.id} className="flex items-center justify-between text-xs border-b border-zinc-100 last:border-0 py-1">
                  <div className="min-w-0">
                    <p className="font-bold text-[#09090B] truncate">{getPrimaryStopSummary(j).title}</p>
                    <p className="text-[10px] text-zinc-500 truncate">{j.tracking_number} · {j._type === "shipment" ? "Spedizione" : "Ritiro"}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        ) : (
          <div className="bg-white rounded-lg border border-zinc-200 p-4 space-y-2">
            <p className="text-xs text-zinc-500">{job.tracking_number} | {job._type === "shipment" ? "Spedizione" : "Ritiro"}</p>
            <p className="text-base font-bold">{getPrimaryStopDetails(job)?.company || getPrimaryStopDetails(job)?.name || getPrimaryStopSummary(job).title}</p>
          </div>
        )}

        <div className="bg-white rounded-lg border border-zinc-200 p-4 space-y-2">
          <p className="text-[10px] font-bold uppercase tracking-widest text-zinc-400">Foto prova di consegna</p>
          {podPhoto ? (
            <div className="relative">
              <img src={podPhoto} alt="POD" className="rounded max-h-40 w-full object-cover border" />
              <button onClick={() => setPodPhoto("")} className="absolute top-1 right-1 bg-black/50 text-white rounded-full p-1"><X size={14} /></button>
            </div>
          ) : (
            <button onClick={() => capturePhoto(setPodPhoto)} className="w-full h-24 border-2 border-dashed border-zinc-300 rounded flex flex-col items-center justify-center text-zinc-400 gap-1" data-testid="pod-photo-btn">
              <Camera size={24} />
              <span className="text-xs font-bold">Scatta foto</span>
            </button>
          )}
        </div>

        <div className="bg-white rounded-lg border border-zinc-200 p-4 space-y-2">
          <p className="text-[10px] font-bold uppercase tracking-widest text-zinc-400">Firma digitale</p>
          <input type="text" value={podSignedBy} onChange={(e) => setPodSignedBy(e.target.value)} placeholder="Nome di chi firma" className="w-full h-10 px-3 border border-zinc-200 rounded-sm text-sm" data-testid="pod-signed-by" />
          {podSignature ? (
            <div className="relative">
              <img src={podSignature} alt="Firma" className="bg-white border rounded p-2 max-h-24 mx-auto" />
              <button onClick={() => setPodSignature("")} className="absolute top-1 right-1 bg-black/50 text-white rounded-full p-1"><X size={14} /></button>
            </div>
          ) : showSignature ? (
            <SignaturePad onSave={(sig) => { setPodSignature(sig); setShowSignature(false); }} onCancel={() => setShowSignature(false)} />
          ) : (
            <button onClick={() => setShowSignature(true)} className="w-full h-16 border-2 border-dashed border-zinc-300 rounded flex items-center justify-center text-zinc-400 gap-1.5" data-testid="pod-sign-btn">
              <PenLine size={18} /> <span className="text-xs font-bold">Raccogli firma</span>
            </button>
          )}
        </div>

        <div className="bg-white rounded-lg border border-zinc-200 p-4 space-y-2">
          <p className="text-[10px] font-bold uppercase tracking-widest text-zinc-400">Note (opzionale)</p>
          <textarea value={podNote} onChange={(e) => setPodNote(e.target.value)} placeholder="Note aggiuntive..." className="w-full h-16 px-3 py-2 border border-zinc-200 rounded-sm text-sm resize-none" />
        </div>

        <button onClick={submitPod} disabled={saving} className="w-full h-14 bg-green-600 text-white font-bold uppercase rounded-sm text-sm disabled:opacity-50 flex items-center justify-center gap-2" data-testid="submit-pod-btn">
          {saving ? <Loader2 size={18} className="animate-spin" /> : <><Check size={18} /> {isMulti ? `Conferma ${multiPodJobs.length} consegne` : (job.status === "consegnato" ? "Salva modifica" : "Conferma e Chiudi")}</>}
        </button>
        <button onClick={() => { if (isMulti) { setMultiPodJobs([]); navigateTo("home"); } else { navigateTo("detail"); } }} className="w-full h-10 border border-zinc-200 text-zinc-600 font-bold text-xs uppercase rounded-sm">Annulla</button>
      </div>
    </div>
  );
}
